module.exports = __webpack_public_path__ + "static/media/a6afca1989997f7b42d335b748e35f75@2x.6faac52e.png";